// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerWrapper":"Footer_footerWrapper__Cn4RY","colB":"Footer_colB__nI5Lv","colC":"Footer_colC__H6arA","colA":"Footer_colA__XjJq5"};